export const servicesRoutes = {
  'route.services.index': '/services',
};
